import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// Cosmos fonts: Sora (display), Jost (UI), IBM Plex Mono (money/numeric)
import '@fontsource/sora/400.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';
import '@fontsource/sora/800.css';
import '@fontsource/jost/300.css';
import '@fontsource/jost/400.css';
import '@fontsource/jost/500.css';
import '@fontsource/jost/600.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './styles/globals.css';
import './i18n';
import '@/utils/soundPreference';
import { TimezoneProvider } from './contexts/TimezoneContext';
import { DeviceModeProvider } from './contexts/DeviceModeContext';
import { readIsMobileLayout } from './utils/isMobileLayout';

/** Avoid 1-frame layout flash before DeviceModeProvider mounts. */
if (typeof document !== 'undefined') {
  const mobile = readIsMobileLayout();
  document.body.dataset.mode = mobile ? 'mobile' : 'desktop';
  document.documentElement.style.setProperty('--wf-bottom-nav-h', mobile ? '56px' : '0px');
}

// Sau deploy mới, chunk cũ có thể 404 — reload để lấy manifest/bundle mới
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TimezoneProvider>
      <DeviceModeProvider>
        <App />
      </DeviceModeProvider>
    </TimezoneProvider>
  </StrictMode>
);
